export default __webpack_public_path__ + "static/media/bell.ee0d8bff.svg";